<div class="time-picker-content" mat-dialog-content>
  <form [formGroup]="slotTimePickerForm" class="timepicker-form">
    <label>{{ 'timepicker.from' | translate }} </label>
    <mat-form-field class="time-display">
      <mat-select (selectionChange)="onBeginningHourSelected()" class="no-arrow" formControlName="beginningHour">
        <mat-option *ngFor="let h of availableBeginningHours" [value]="h"
                    class="no-validate-option">{{ h < 10 ? '0' + h : h }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="time-display">
      <mat-select (selectionChange)="onBeginningMinuteSelected()" class="no-arrow" formControlName="beginningMinute">
        <mat-option *ngFor="let m of availableBeginningMinutes" [value]="m"
                    class="no-validate-option">{{ m < 10 ? '0' + m : m }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <label id="to-label">{{ 'timepicker.to' | translate }} </label>
    <mat-form-field class="time-display">
      <mat-select (selectionChange)="onEndHourSelected()" class="no-arrow" formControlName="endHour">
        <mat-option *ngFor="let h of availableEndHours" [value]="h"
                    class="no-validate-option">{{ h < 10 ? '0' + h : h }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="time-display">
      <mat-select (selectionChange)="onEndMinuteSelected()" class="no-arrow" formControlName="endMinute">
        <mat-option *ngFor="let m of availableEndMinutes" [value]="m"
                    class="no-validate-option">{{ m < 10 ? '0' + m : m }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>
